import { Slot } from '@radix-ui/react-slot';
import clsx from 'clsx';
import { ComponentProps } from 'react';
import { inputIconButton } from './input-icon-button.css';

type InputIconButtonProps = ComponentProps<'button'> & { asChild?: boolean };

export const InputIconButton = ({
  children,
  ref,
  className,
  asChild,
  ...props
}: InputIconButtonProps) => {
  const Component = asChild ? Slot : 'button';

  return (
    <Component
      ref={ref}
      role="button"
      type={'button'}
      tabIndex={0}
      className={clsx(inputIconButton, className)}
      {...props}
    >
      {children}
    </Component>
  );
};
